var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31891 14.5027L4.4835 17.6213L1.43011 17.6859C0.517594 15.9934 0 14.057 0 11.9992C0 10.0093 0.483938 8.13277 1.34175 6.48047H1.34241L4.06078 6.97884L5.25159 9.68091C5.00236 10.4075 4.86652 11.1875 4.86652 11.9992C4.86661 12.88 5.02617 13.724 5.31891 14.5027Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7903 9.75781C23.9281 10.4837 24 11.2334 24 11.9996C24 12.8587 23.9097 13.6967 23.7376 14.5051C23.1534 17.2558 21.627 19.6578 19.5125 21.3576L19.5119 21.3569L16.088 21.1822L15.6034 18.1572C17.0064 17.3343 18.1029 16.0466 18.6805 14.5051H12.2638V9.75781H18.7741H23.7903Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5119 21.3577L19.5125 21.3584C17.4561 23.0113 14.8437 24.0004 12 24.0004C7.43012 24.0004 3.45694 21.4461 1.43011 17.6872L5.31891 14.5039C6.3323 17.2085 8.94132 19.1338 12 19.1338C13.3147 19.1338 14.5464 18.7784 15.6033 18.158L19.5119 21.3577Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6595 2.76262L15.7721 5.94525C14.6782 5.26153 13.3852 4.86656 12 4.86656C8.87206 4.86656 6.21425 6.88017 5.25163 9.68175L1.34239 6.48131H1.34174C3.33889 2.63077 7.36217 0 12 0C14.9116 0 17.5813 1.03716 19.6595 2.76262Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d846a2ae.svg";
export { ForwardRef as ReactComponent };